var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.width && !!_vm.height)?_c('div',{staticClass:"element-image"},_vm._l((_vm.element.components),function(component,i){return _c('component-image',{key:i,attrs:{"element":_vm.element,"image":_vm.image(component),"component":component,"width":_vm.width,"height":_vm.height,"preview-context":_vm.previewContext}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }